import React from 'react';
import MapRadius from '../../../element/mapRadius';
import Title from '../../../element/title';
import clone from 'clone';
import url from '../../../urlhandler/urlHandlerActions';
import { findIndex } from 'underscore';

const $ = jQuery;

class MapRadiusPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      'values': [],
      'options': [],
      'rangeValues': {},
      'toogle': true,
    };
    this.isEditable = API.isEditable ? true : false;
    this.changeToogle = this.changeToogle.bind(this);
    this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
    this.handleRangeSelect = this.handleRangeSelect.bind(this);
    this.errorMessage = null;
  }
  componentDidMount() {
    const block = clone(this.props.block);
    this.processData(this.props, block);
  }
  componentWillReceiveProps(nextprops) {
    this.processData(nextprops, nextprops.block);
  }
  processData(props, block) {
    this.helperData = clone(this.props.helperData);
    this.block = block;
    this.props = props;
    let options = [];
    let values = this.state.values;
    const rangeValues = {};
    this.setState({
      options, values, rangeValues,
    });
  }
  handleRangeSelect(from) {
    const values = [{ start: from !== undefined ? from : 100 }];
    if (this.searchItem) {
      url.push({
        'searchItem': this.searchItem, // keys
        'searchType': this.searchType,
        'searchField': 'rangeInput', // taxonomies or metakeys,
        'metakey': this.searchItem,
        values,
      });
      this.errorMessage = null;
    } else {
      this.errorMessage = 'Please select your metadata first from edit panel';
    }
    this.setState({ rangeValues: { min: from } });
  }
  changeToogle() {
    const toogle = !this.state.toogle;
    this.setState({ toogle });
  }
  render() {
    this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
    if (REBUILDER.hasOwnProperty(this.metakey)) {
      this.previewData = REBUILDER[this.metakey].previewData ? REBUILDER[this.metakey].previewData : {};
    }
    const textBoxClassName = this.props.block.dynamicNameClassTextBox;
    const HelperClass = this.state.toogle ? 'single-component' : '';
    let max = Number(this.props.block.maxvalue);
    let min = Number(this.props.block.minvalue);
    const allLayout = clone(this.props.allLayout);
    const options = [];
    let isDataTypeSet = false;
    const index = findIndex(allLayout, { uid: this.props.uid });
    if (this.props.block.maxvalue === undefined) {
      max = parseInt(100, 10);
    }
    if (this.props.block.minvalue === undefined) {
      min = parseInt(0, 10);
    }
    if (this.state.rangeValues.min === undefined) {
      this.state.rangeValues.min = parseInt(min, 10);
    }

    return (<div className={textBoxClassName}>
      <Title
        title={this.props.block.title}
        subtitle={this.props.block.subtitle}
        toogle= {this.state.toogle}
        onToogle = {this.changeToogle}
        selectedToogleViewType = {this.props.block.selectedToogleViewType}
      />
      { this.state.toogle ? <div className={HelperClass}>
        <MapRadius values={this.state.rangeValues} maxvalue={max} minvalue={min} grabRangeSelectValue={this.handleRangeSelect} unit={this.props.block.unit} />
      </div>
      : null}
    </div>);
  }
}

MapRadiusPreview.propTypes = {
  'urlData': React.PropTypes.object,
  'block': React.PropTypes.object,
  'helperData': React.PropTypes.object,
  'previewData': React.PropTypes.object,
  'shortcodeKey': React.PropTypes.number,
};

export default MapRadiusPreview;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/search/default/mapRadiusPreview.js
 **/